module.exports = __webpack_public_path__ + "public/img/img_05.0c6556cd.png";